import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RequestSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RequestSVG;
